module.exports = __webpack_public_path__ + "img/entrepreneur.3a1b0f4e.svg";